// extracted by css-extract-rspack-plugin
export default {"resetText":"ForgotPassword_resetText__kYJwy","clickHere":"ForgotPassword_clickHere__-xTtd"};